import { createContext } from 'react';
import type { AuthenticatedPayload, OrganizationSummary, SessionUser } from './api/auth';

/**
 * Contexto e tipos num arquivo sem componente: um módulo que exporta componente **e** valor
 * comum desliga o fast refresh do Vite, e a página inteira recarregaria a cada salvamento.
 */

export interface AuthState {
  user: SessionUser | null;
  organization: OrganizationSummary | null;
  organizations: OrganizationSummary[];
  permissions: string[];
  /** Conta do painel da plataforma (ADR-027): não entra em empresa nenhuma. */
  isPlatform: boolean;
  /** `true` enquanto a restauração inicial da sessão não terminou. */
  isRestoring: boolean;
}

export interface AuthContextValue extends AuthState {
  applySession: (payload: AuthenticatedPayload) => void;
  logout: () => Promise<void>;
  switchOrganization: (organizationId: string) => Promise<void>;
  /** Conveniência de interface — quem nega de verdade é o backend. */
  can: (permission: string) => boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
